import { useMutation } from '@tanstack/react-query';

import { authApi } from '../api/auth-api';

/** Always 202 for a well-formed email; the page never learns whether the account exists. */
export function useRequestMagicLink() {
  return useMutation({ mutationFn: authApi.requestMagicLink, meta: { silentError: true } });
}
